export default {
  isCopyKey: true,
  timespan: 7000,

  type: null,
  content: null,
}
